var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteAccountPopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 160,
    viewBox: "0 0 162 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.98 160H6.61693C2.96621 160 0 157.034 0 153.365V6.61693C0 2.9662 2.94865 0 6.61693 0H154.98C158.631 0 161.615 2.94865 161.615 6.61693V153.365C161.597 157.016 158.631 160 154.98 160Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.597 15.6384V6.61693C161.597 2.96621 158.631 0 154.963 0H6.61693C2.96621 0 0 2.94865 0 6.61693V15.6384H161.597Z",
    fill: "#7587A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.467 101.764C114.448 89.783 114.448 70.3576 102.467 58.3764C90.4853 46.3952 71.0599 46.3952 59.0787 58.3764C47.0975 70.3576 47.0975 89.783 59.0787 101.764C71.0599 113.745 90.4853 113.745 102.467 101.764Z",
    fill: "#D32F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8694 69.2847L91.5701 63.9854L64.6885 90.8669L69.9878 96.1663L96.8694 69.2847Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.57 96.1524L96.8694 90.853L69.9878 63.9714L64.6884 69.2708L91.57 96.1524Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccountPopup);
export default __webpack_public_path__ + "static/media/delete_account_popup.b983bbd73b4688e8b884c6290678927a.svg";
export { ForwardRef as ReactComponent };